var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"un-authorized-page valign-center flex-center"},[_c('span',[_vm._v("用户没有权限")])])
}]

export { render, staticRenderFns }